import { render, staticRenderFns } from "./MtCheckbox.vue?vue&type=template&id=331091f3&scoped=true&"
import script from "./MtCheckbox.vue?vue&type=script&lang=js&"
export * from "./MtCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MtCheckbox.vue?vue&type=style&index=0&id=331091f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331091f3",
  null
  
)

export default component.exports